import {
    CO_OFFER_ADD,
    CO_OFFER_SUCCESS,
    CO_OFFER_FAIL,
    CO_GET_OFFERS_LISTING,
    CO_GET_OFFERS_LISTING_SUCCESS,
    CO_GET_OFFERS_LISTING_FAILED,
    CO_OFFER_DELETE,
    CO_OFFER_DELETE_SUCCESS,
    CO_OFFER_DELETE_FAIL,
    CO_OFFER_EDIT,
    CO_OFFER_EDIT_SUCCESS,
    CO_OFFER_EDIT_FAIL,
    CO_OFFER_UPDATE,
    CO_OFFER_UPDATE_SUCCESS,
    CO_OFFER_UPDATE_FAIL,
    CO_CHANGE_OFFER_STATUS,
    CO_CHANGE_OFFER_STATUS_SUCCESS,
    CO_CHANGE_OFFER_STATUS_FAIL,
  } from "./actionTypes"
  
  const initialState = {
    error: null,
    loading: false,
    msg: null,
    offer: [],
    offerDelete: null,
    offerEdit: null,
    offerUpdate: null,
  }
  
  const coOffer = (state = initialState, action) => {
    switch (action.type) {
      case CO_OFFER_ADD:
        state = {
          ...state,
          loading: true,
          error: null,
          msg: null,
          offer: action.payload,
        }
        break
      case CO_OFFER_SUCCESS:
        state = {
          ...state,
          loading: false,
          error: null,
          msg: null,
          offer: action.payload,
        }
        break
      case CO_OFFER_FAIL:
        state = {
          ...state,
          loading: false,
          msg: null,
          error: action.payload !== "light" ? action.payload : "",
        }
        break
      case CO_GET_OFFERS_LISTING:
        state = {
          ...state,
          loading: true,
          error: null,
          msg: null,
          offer: action.payload,
        }
        break
      case CO_GET_OFFERS_LISTING_SUCCESS:
        state = { ...state, error: null, msg: null, loading: false, offer: action.payload }
        break
      case CO_GET_OFFERS_LISTING_FAILED:
        state = {
          ...state,
          loading: false,
          msg: null,
          error: action.payload !== "light" ? action.payload : "",
        }
        break
      case CO_OFFER_DELETE:
        state = {
          ...state,
          loading: true,
          error: null,
          msg: null,
          offerDelete: action.payload,
        }
        break
      case CO_OFFER_DELETE_SUCCESS:
        state = {
          ...state,
          loading: false,
          error: null,
          msg: null,
          offer: state.offer.filter(offer => {
            return offer.offer_id !== action.payload.id
          }),
        }
        break
      case CO_OFFER_DELETE_FAIL:
        return {
          ...state,
          loading: false,
          msg: null,
          error: action.payload !== "light" ? action.payload : "",
        }
        break
      case CO_OFFER_EDIT:
        state = {
          ...state,
          loading: true,
          error: null,
          msg: null,
          offerEdit: action.payload,
        }
        break
      case CO_OFFER_EDIT_SUCCESS:
        if (state === null || state.offer.length === 0) {
          state = {
            ...state,
            loading: false,
            error: null,
            msg: null,
            offer: [...state.offer, action.payload],
          }
        } else {
          state = {
            ...state,
            loading: false,
            error: null,
            msg: null,
            offer: state.offer.map(i =>
              i.offer_id === action.payload.offer_id ? action.payload : i
            ),
          }
        }
        break
      case CO_OFFER_EDIT_FAIL:
        state = {
          ...state,
          loading: false,
          msg: null,
          error: action.payload !== "light" ? action.payload : "",
        }
        break
      case CO_OFFER_UPDATE:
        state = {
          ...state,
          loading: true,
          error: null,
          msg: null,
          offerUpdate: action.payload,
        }
        break
      case CO_OFFER_UPDATE_SUCCESS:
        state = { ...state, error: null, loading: false }
        break
      case CO_OFFER_UPDATE_FAIL:
        state = {
          ...state,
          loading: false,
          msg: null,
          error: action.payload !== "light" ? action.payload : "",
        }
        break
      case CO_CHANGE_OFFER_STATUS:
        state = {
          ...state,
          loading: true,
          error: null,
          msg: null,
        }
        break
      case CO_CHANGE_OFFER_STATUS_SUCCESS:
        const index = state.offer.findIndex(
          offer => offer.offer_id === action.payload.id
        )
        let newOfferAfterStatusChange = []
        newOfferAfterStatusChange = [...state.offer] //making a new array
        newOfferAfterStatusChange[index].status =
          !newOfferAfterStatusChange[index].status
  
        state = {
          ...state,
          loading: false,
          error: null,
          msg: null,
          offer: newOfferAfterStatusChange,
        }
        break
      case CO_CHANGE_OFFER_STATUS_FAIL:
      default:
        state = {
          ...state,
          loading: false,
          msg: null,
          error: action.payload !== "light" ? action.payload : "",
        }
        break
    }
    return state
  }
  
  export default coOffer
  